var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"index"}},[_c('div',{staticClass:"banner"},[_c('el-carousel',{attrs:{"height":"420px"}},_vm._l((_vm.banners),function(items,index){return _c('el-carousel-item',{key:index},[_c('img',{attrs:{"src":items.ImageArrays,"title":items.Title},on:{"click":function($event){return _vm.JumpUrlFunc(index)}}})])}),1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df54eb3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page2/banner/banner.vue
// module id = null
// module chunks = 